<div class="flex items-center justify-between !gap-2">
    <p class="first-letter:uppercase">
        {{ label | translate }}
        <span *ngIf="numLabel">x {{ numLabel }}</span>
    </p>
    <p class="text-palette-gray-900">
        <ng-container *ngIf="isOriginalCurrency; else exchangePrice">
            <span *ngIf="!showMarketCurrencyOnly; then originDiscount; else originDiscountHistory"></span>
            <ng-template #originDiscount>
                {{ deduct ? '- ' : '' }}{{ (price && price >= 0 ? price : 0) | historyCurrency : exchangeRate.exchange_rate_value : exchangeRate.currency_exchange_rate : currency?.currency }}
            </ng-template>
            <ng-template #originDiscountHistory>{{ deduct ? '- ' : '' }} {{ transformCurrencyPayment(price && price >= 0 ? price : 0) }}</ng-template>
        </ng-container>
        <ng-template #exchangePrice>
            {{ deduct ? '- ' : '' }}
            <app-price-format [price]="price && price >= 0 ? price : 0"></app-price-format>
        </ng-template>
    </p>
</div>
